import Vue from "vue";
import VueTour from "vue-tour";
import { inject, provide } from "@vue/composition-api";

Vue.use(VueTour);

const tourSymbol = Symbol();

export function provideTour() {
    const tour = VueTour;

    provide(tourSymbol, tour);
}

export function useTourPlugin() {
    const tour = inject(tourSymbol);
    if (!tour) {
        throw new Error("No tour provided.");
    }

    return {
        ...Vue.prototype.$tours,
    };
}
